import { useSelector } from "react-redux";
import { selectClientsList } from "../../../../redux/client/selectors";
import css from "./ChoseClientPopup.module.css";
import { IoIosSearch } from "react-icons/io";
import { BsCheck } from "react-icons/bs";
import { SiTicktick } from "react-icons/si";
import { RxCross1 } from "react-icons/rx";
import { useEffect, useMemo, useRef, useState } from "react";

export default function ChoseClientPopup({
  onClose,
  isOpen,
  buttonRef,
  setChosenClientName,
  setChosenClientPhone,
  setChosenClientCars,
  clients,
}) {
  const inputRef = useRef(null);
  const popupRef = useRef(null);
  const [filter, setFilter] = useState("");
  const [chosenClientId, setChosenClientId] = useState(null);

  // const clients = useSelector(selectClientsList);
  console.log("clients", clients);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleClickOutside = event => {
    if (
      popupRef.current &&
      !popupRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      onClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  // Фільтр
  const visibleContacts = useMemo(() => {
    if (!filter.trim()) return clients; // ← Повертаємо весь список, якщо фільтр порожній

    const normalizePhone = phone => phone?.replace(/\D/g, "") ?? "";

    const normalizedFilter = filter.replace(/\D/g, "");
    const lowerCaseFilter = filter.toLowerCase();

    return clients?.filter(contact => {
      const normalizedPhone = normalizePhone(contact?.phone);
      const normalizedPhoneNumber1 = normalizePhone(contact?.phoneNumber1);
      const normalizedPhoneNumber2 = normalizePhone(contact?.phoneNumber2);

      return (
        contact?.first_name?.toLowerCase().includes(lowerCaseFilter) ||
        contact?.last_name?.toLowerCase().includes(lowerCaseFilter) ||
        contact?.company_name?.toLowerCase().includes(lowerCaseFilter) ||
        (normalizedFilter &&
          (normalizedPhone.includes(normalizedFilter) ||
            normalizedPhoneNumber1.includes(normalizedFilter) ||
            normalizedPhoneNumber2.includes(normalizedFilter)))
      );
    });
  }, [clients, filter]);

  // Сортування

  const getSortName = client => client?.first_name || client?.company_name || "";

  const sortedArray = [...visibleContacts].sort((a, b) =>
    getSortName(a).localeCompare(getSortName(b), "uk", {
      sensitivity: "base",
    })
  );

  // Дефолтна аватарка
  const getInitials = ({ first_name, last_name, company_name }) => {
    // 1️⃣ first + last (пріоритет)
    if (first_name || last_name) {
      const first = first_name?.trim()?.[0] || "";
      const last = last_name?.trim()?.[0] || "";
      return `${first}${last}`.toUpperCase();
    }

    // 2️⃣ company name
    if (company_name) {
      return company_name.trim()[0]?.toUpperCase() || "";
    }

    return "";
  };

  const getStableColor = key => {
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
      hash = key.charCodeAt(i) + ((hash << 5) - hash);
    }
    return "#" + (hash >>> 0).toString(16).padStart(6, "0").slice(0, 6);
  };

  const handleChooseClient = e => {
    e.stopPropagation();
    if (chosenClientId) {
      const selectedClient = clients.find(
        client => client.id === chosenClientId
      );
      if (selectedClient) {
        const phoneOptions = [
          selectedClient.phone,
          selectedClient.phoneNumber1,
          selectedClient.phoneNumber2,
          selectedClient.manager_phone,
        ];

        const validPhone = phoneOptions.find(
          phone =>
            typeof phone === "string" && /^\+?\d{10,15}$/.test(phone.trim())
        );

        setChosenClientName(
          `${selectedClient?.first_name || ""} ${
            selectedClient?.last_name || ""
          }`.trim() ||
            selectedClient?.company_name ||
            ""
        );
        setChosenClientPhone(validPhone || null);
        setChosenClientCars(selectedClient?.vehicles || []);
      }
    }
    onClose();
  };

  return (
    <div className={css.wrapper} ref={popupRef}>
      <div className={css.inputBox}>
        <IoIosSearch className={css.inputIcon} />
        <input
          ref={inputRef}
          className={css.input}
          placeholder="3807332..."
          value={filter}
          onChange={e => setFilter(e.target.value)}
        />
        {chosenClientId && (
          <div className={css.btnsBox}>
            <button
              type="button"
              className={`${css.btns} ${css.btnReset}`}
              onClick={() => setChosenClientId(null)}
            >
              <RxCross1 className={css.icon} />
            </button>
            <button
              type="button"
              onClick={handleChooseClient}
              className={`${css.btns} ${css.btnConfirm}`}
            >
              <SiTicktick className={css.icon} />
            </button>
          </div>
        )}
      </div>
      <ul className={css.userList}>
        {sortedArray?.map((user, index) => (
          <li key={index} className={css.userListItem}>
            {user?.photo || user?.avatar ? (
              <img
                src={user?.photo || user?.avatar}
                alt="client photo"
                className={`${css.userPhoto} ${css.img}`}
              />
            ) : (
              <div
                className={`${css.userPhoto} ${css.noPhoto}`}
                style={{
                  backgroundColor: getStableColor(
                    `${user?.first_name || user?.company_name}-${
                      user?.phone || user?.phoneNumber1
                    }`
                  ),
                }}
              >
                {getInitials(user)}
              </div>
            )}
            <div className={css.phoneNameBox}>
              <p className={css.userName}>
                {user?.first_name || user?.last_name
                  ? `${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim()
                  : user?.company_name}
              </p>
              <p className={css.userPhone}>
                {/^[+0-9]+$/.test(user?.phone)
                  ? user?.phone
                  : user?.phone || user.manager_phone}
              </p>
            </div>
            <label className={css.label} onClick={e => e.stopPropagation()}>
              <input
                type="radio"
                name="client"
                id="client"
                className={css.checkbox}
                checked={Number(chosenClientId) === Number(user?.id)}
                onChange={() => setChosenClientId(user?.id)}
              />
              <span className={css.cbMark}>
                <BsCheck className={css.cbIcon} />
              </span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}
